import {getAllIssueWrappersSorted, getCurrentSheets} from '../selectors';
import lodashGet from 'lodash/get';
import {batchClearPushpinAction, batchCreatePushpinAction} from './pushpin-actions';

export const JSONAPI_CONFIGURE = 'JSONAPI_CONFIGURE';
export const JSONAPI_CONFIGURE_DOCS_SDK = 'JSONAPI_CONFIGURE_DOCS_SDK';
export const OXYGEN_CONFIGURE_START = 'OXYGEN_CONFIGURE_START';
export const OXYGEN_CONFIGURE_ASYNC = 'OXYGEN_CONFIGURE_ASYNC';
export const OXYGEN_CONFIGURE_USERS_START = 'OXYGEN_CONFIGURE_USERS_START';
export const OXYGEN_CONFIGURE_USERS_ASYNC = 'OXYGEN_CONFIGURE_USERS_ASYNC';
export const OXYGEN_CONFIGURE_ASYNC_PENDING = 'OXYGEN_CONFIGURE_ASYNC_PENDING';
export const OXYGEN_CONFIGURE_ASYNC_FULFILLED = 'OXYGEN_CONFIGURE_ASYNC_FULFILLED';
export const OXYGEN_CONFIGURE_ASYNC_REJECTED = 'OXYGEN_CONFIGURE_ASYNC_REJECTED';
export const OXYGEN_CONFIGURE_USERS_ASYNC_PENDING = 'OXYGEN_CONFIGURE_USERS_ASYNC_PENDING';
export const OXYGEN_CONFIGURE_USERS_ASYNC_FULFILLED = 'OXYGEN_CONFIGURE_USERS_ASYNC_FULFILLED';
export const OXYGEN_CONFIGURE_USERS_ASYNC_REJECTED = 'OXYGEN_CONFIGURE_USERS_ASYNC_REJECTED';
export const DOCUMENT_COLLECTION_CONFIGURE = 'DOCUMENT_COLLECTION_CONFIGURE';
export const DOCUMENTS_WITH_ISSUES_FETCH = 'DOCUMENTS_WITH_ISSUES_FETCH';
export const DOCUMENT_CONFIGURE = 'DOCUMENT_CONFIGURE';
export const DOCUMENT_CONFIGURE_PENDING = 'DOCUMENT_CONFIGURE_PENDING';
export const DOCUMENT_CONFIGURE_FULFILLED = 'DOCUMENT_CONFIGURE_FULFILLED';
export const DOCUMENT_CONFIGURE_REJECTED = 'DOCUMENT_CONFIGURE_REJECTED';
export const SET_SHEETS_CONFIGURATION = 'SET_SHEETS_CONFIGURATION';
export const ANALYTICS_CONFIGURE = 'ANALYTICS_CONFIGURE';
export const ISSUE_TYPES_API_CONFIGURE = 'ISSUE_TYPES_API_CONFIGURE';
export const REQUIRED_FIELDS_CONFIGURE_API = 'REQUIRED_FIELDS_CONFIGURE_API';
export const ISSUE_ATTRIBUTES_API_CONFIGURE = 'ISSUE_ATTRIBUTES_API_CONFIGURE';
export const ISSUE_ROOT_CAUSES_API_CONFIGURE = 'ISSUE_ROOT_CAUSES_API_CONFIGURE';
export const DOCUMENT_VERSIONS_API_START = 'DOCUMENT_VERSIONS_API_START';
export const DOCUMENT_VERSIONS_API_FULFILLED = 'DOCUMENT_VERSIONS_API_FULFILLED';
export const DOCUMENT_LOADED = 'DOCUMENT_LOADED';
export const CHECKLISTS_WITH_ISSUES_FETCH = 'CHECKLISTS_WITH_ISSUES_FETCH';
export const CHECKLISTS_WITH_ISSUES_FETCH_FULFILLED = 'CHECKLISTS_WITH_ISSUES_FETCH_FULFILLED';

export const configureJsonApiAction = apiConfig => ({
  type: JSONAPI_CONFIGURE,
  payload: apiConfig
});

export const configureJsonApiDocsSDKAction = docsSDK => (dispatch, getState, extraArgument) => {
  extraArgument.docsSDK = docsSDK;
};

export const configureAnalyticsAction = analyticsConfig => ({
  type: ANALYTICS_CONFIGURE,
  payload: analyticsConfig
});

export const configureIssueTypesApiAction = apiConfig => ({
  type: ISSUE_TYPES_API_CONFIGURE,
  payload: apiConfig
});

export const configureIssueAttributesApiAction = apiConfig => ({
  type: ISSUE_ATTRIBUTES_API_CONFIGURE,
  payload: apiConfig
});

export const configureIssueRootCausesApiAction = apiConfig => ({
  type: ISSUE_ROOT_CAUSES_API_CONFIGURE,
  payload: apiConfig
});

export const configureOxygenAction = oxygenPromises => ({
  type: OXYGEN_CONFIGURE_START,
  payload: oxygenPromises
});

export const configureOxygenUserAction = users => (dispatch, getState, {adminApi}) => {
  const {limit, offset, totalResults} = users.pagination;
  const promises = [];
  for (let i = 1; i < totalResults / limit; i++) {
    promises.push(adminApi.getProjectUsers({offset: offset + i * limit, limit}));
  }

  dispatch({
    type: OXYGEN_CONFIGURE_USERS_START,
    payload: {userPromises: promises}
  });
};

export const setOxygenEntitiesAction = payload => ({
  type: OXYGEN_CONFIGURE_ASYNC_FULFILLED,
  payload
});

export const configureDocumentAction = documentConfig => {
  const {documentPromise} = documentConfig;
  return {
    type: DOCUMENT_CONFIGURE,
    payload: {
      promise: documentPromise
    }
  };
};

export const configureDocumentSuccessAction = document => ({
  type: DOCUMENT_CONFIGURE_FULFILLED,
  payload: document
});

export const configureSheetsAction = ({currentSheets = [], sheetList = []}) => (dispatch, getState) => {
  const state = getState();
  const prevSheets = getCurrentSheets(state);

  // This should only happen when we're viewing a single sheet, do nothing if either prev or new sheet list contains more than one sheet
  if (prevSheets.length <= 1 && currentSheets.length <= 1) {
    const currentSheetGuid = lodashGet(prevSheets, '[0].sheetGuid');
    const newSheetGuid = lodashGet(currentSheets, '[0].sheetGuid');

    if (currentSheetGuid && currentSheetGuid !== newSheetGuid) {
      const issues = getAllIssueWrappersSorted(state).map(issueWrapper => issueWrapper.attributes);
      dispatch(batchClearPushpinAction(issues));
      dispatch(batchCreatePushpinAction(issues, currentSheets[0]));
    }
  }
  dispatch({
    type: SET_SHEETS_CONFIGURATION,
    payload: {sheetList, currentSheets}
  });
};
